/* Retry helper with exponential backoff
 * Usage:
 * await withRetry(() => somePromiseReturningFn(), { maxAttempts: 4, baseDelayMs: 300 })
 */

export const promiseDelay = ms =>
  new Promise(resolve => {
    setTimeout(resolve, ms);
  });

export async function withRetry(fn, { maxAttempts = 3, baseDelayMs = 300 } = {}) {
  let attempt = 1;
  // eslint-disable-next-line no-constant-condition
  while (true) {
    try {
      return await fn();
    } catch (err) {
      if (attempt >= maxAttempts) throw err;
      const delay = baseDelayMs * 2 ** (attempt - 1);
      await promiseDelay(delay);
      attempt += 1;
    }
  }
}
